export default __webpack_public_path__ + "static/logoticker_elle-bfa0855146618fd455b00ebe40d5378f.svg";